<template>
  <component
    :is="isMobile ? CoreBottomSheet : CoreDialog"
    v-model="isOpened"
    v-bind="isMobile
      ? {} : {
        size: 'lg',
        title: t('Программа лояльности клиники', options),
        divider: true,
      }"
    data-qa="lpu_loyalty_program_info"
  >
    <template
      v-if="!isMobile"
      #prependBtn="{ btnProps }"
    >
      <v-btn
        v-bind="btnProps"
        @click="isOpened = false"
      >
        <span class="ui-icon-close-not-a-circle" />
      </v-btn>
    </template>

    <div
      v-if="isMobile"
      class="text-subtitle-1 text--text text-center mb-3"
    >
      {{ t('Программа лояльности клиники', options) }}
    </div>

    <div
      data-qa="lpu_loyalty_program_info"
      class="d-flex flex-column gr-5"
    >
      <BonusLevels
        :bonus-levels="bonusLevels"
      />
      <WelcomeBonus
        v-if="welcomeBonusAmount"
        :welcome-bonus-amount="welcomeBonusAmount"
      />
      <BriefDetails
        :max-payment-percent="maxPaymentPercent"
      />
    </div>
    <template #actions>
      <div class="d-flex flex-column flex-grow-1 gr-4">
        <v-btn
          v-if="isMobile"
          data-qa="lpu_loyalty_program_info_btn_confirm"
          color="primary"
          class="branding-btn branding-btn--primary"
          depressed
          @click="isOpened = false"
        >
          {{ t('Хорошо', options) }}
        </v-btn>
        <span
          class="text-body-2 text-secondary--text text-center text-pre-line"
        >{{ t('Полные условия и ограничения программы\nуточняйте в клинике', options) }}</span>
      </div>
    </template>
  </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import useIsMobile from 'src/composables/useIsMobile'
import CoreBottomSheet from 'src/core/CoreBottomSheet/CoreBottomSheet.vue'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import type { BonusLevel } from 'src/components/common/LpuLoyaltyProgram/types'
import BonusLevels from 'src/components/common/LpuLoyaltyProgram/components/LpuLoyaltyProgramInfo/components/BonusLevels.vue'
import BriefDetails from 'src/components/common/LpuLoyaltyProgram/components/LpuLoyaltyProgramInfo/components/BriefDetails.vue'
import WelcomeBonus from 'src/components/common/LpuLoyaltyProgram/components/LpuLoyaltyProgramInfo/components/WelcomeBonus.vue'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  bonusLevels: BonusLevel[]
  welcomeBonusAmount?: number
  maxPaymentPercent: number
  value: boolean
}>()

const isMobile = useIsMobile()

type Emits = {
  (_event: 'input', _value: boolean): void
}

const emit = defineEmits<Emits>()

const isOpened = computed({
  get() {
    return props.value
  },
  set(value: boolean) {
    emit('input', value)
  },
})
</script>
